import { defaultWalletConnectChainRegistry } from '@layerswap/wallet-core';
import { registerEvmWalletConnectChain } from '@layerswap/wallet-evm';
import { registerSolanaWalletConnectChain } from '@layerswap/wallet-svm';
import { registerStellarWalletConnectChain } from '@layerswap/wallet-stellar';
export function registerDefaultWalletConnectChains(registry = defaultWalletConnectChainRegistry) {
    registerEvmWalletConnectChain(registry);
    registerSolanaWalletConnectChain(registry);
    registerStellarWalletConnectChain(registry);
}
